module.exports = __webpack_public_path__ + "static/media/149220.88688cf0.svg";